export class ValueEnabledTitleModel {
  public enabled: boolean;
  public value: string;
  public title: string;
  constructor(valueEnabled?: {enabled?: boolean | null; value?: string | null; title?: string | null}) {
    this.enabled = !!valueEnabled?.enabled;
    this.value = valueEnabled?.value ?? '';
    this.title = valueEnabled?.title ?? '';
  }
}
